import Box from "@mui/material/Box";
import React from "react";

export const DealPageDrawerHeader = () => {
    return (
        <Box
            style={{
                width: '100%',
                padding: '5px 0px 5px 10px'
            }}
            className={'DealPage-header'}
        >
        </Box>
    )
}